import { useState } from "react"
import { useParams } from "react-router-dom"
import {
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import MoneyReceiptsTab from "./MoneyReceiptsTab"
import QuotationsTab from "./QuotationsTab"
import PageWrapper from "components/Common/PageWrapper"
import { useCustomer } from "hooks/useCustomer"
import { ProfileCard } from "./Profile"

const CustomerProfile = () => {
  const { identifier } = useParams()
  const { data, isLoading } = useCustomer(identifier)
  const customer = data?.data || {}
  const [activeTab, setActiveTab] = useState("money-receipts")

  document.title = `${isLoading ? "Loading..." : customer?.name ?? ""} | ${
    identifier ?? ""
  }`

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  return (
    <PageWrapper
      title="Customer List"
      breadcrumbItem="Profile"
      cardBody={false}
    >
      <Row>
        {/* Left Column */}
        <Col lg="4" className="mb-4">
          <ProfileCard loading={isLoading} data={customer} />
        </Col>

        {/* Right Column */}
        <Col lg="8">
          <Nav pills className="nav-pills-custom mb-4">
            {[
              {
                id: "money-receipts",
                label: "Money Receipts",
                icon: "bx bx-receipt",
              },
              {
                id: "quotations",
                label: "Quotations",
                icon: "bx bx-file",
              },
            ]?.map(tab => (
              <NavItem key={tab.id}>
                <NavLink
                  className={classnames({ active: activeTab === tab.id })}
                  onClick={() => toggleTab(tab.id)}
                >
                  {tab.icon && <i className={`${tab.icon} me-2`}></i>}
                  {tab.label}
                  {tab.count !== undefined && ` (${tab.count})`}
                </NavLink>
              </NavItem>
            ))}
          </Nav>

          <TabContent activeTab={activeTab}>
            {/* Money Receipts Tab */}
            <TabPane tabId="money-receipts">
              <MoneyReceiptsTab />
            </TabPane>
            {/* Quotations Tab */}
            <TabPane tabId="quotations">
              <QuotationsTab customer={customer} />
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    </PageWrapper>
  )
}

export default CustomerProfile
